import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from "@angular/core";
import { SmartMapComponent } from "../smart-map/smart-map.component";
import { Subscription } from "rxjs";

@Component({
    selector: 'app-base-stations-list',
    templateUrl: './base-stations-list.component.html',
    styleUrls: ['./base-stations-list.component.scss']
})
export class BaseStationsListComponent implements OnInit, OnDestroy {
    @Input() caseId: string;
    @Input() currentMap: SmartMapComponent;
    @Input() isReadOnly: boolean = false;
    @Input() baseStations: any[] = [];
    @Input() isInvestigator: boolean = false;
    /** Parent-owned visibility; keeps Tune panel and Map tools toggles in sync. */
    @Input() isBaseStationFilterOn: boolean = true;

    @Output() addAntennaBasedLocation = new EventEmitter<any>();
    @Output() editAntennaBasedLocation = new EventEmitter<any>();
    @Output() locateAreaInterestOutput = new EventEmitter<any>();
    @Output() toggleBaseStations = new EventEmitter<boolean>();

    private subscriptions: Subscription[] = [];

    constructor() { }

    ngOnInit(): void {
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }

    onFilterToggle(value: boolean): void {
        this.toggleBaseStations.emit(value);
    }

    addBaseStation() {
        if (!this.isInvestigator)
            this.addAntennaBasedLocation.emit();
    }

    onSelectBaseStation(baseStation: any): void {
        this.editAntennaBasedLocation.emit(baseStation);
    }

    locateAreaInterest(event: any, baseStation: any): void {
        if (event) {
            event.stopPropagation();
        }
        this.locateAreaInterestOutput.emit(baseStation);
    }
}
